import { render, staticRenderFns } from "./DisponibilitaAccordion.vue?vue&type=template&id=ec556f06&scoped=true"
import script from "./DisponibilitaAccordion.vue?vue&type=script&lang=js"
export * from "./DisponibilitaAccordion.vue?vue&type=script&lang=js"
import style0 from "./DisponibilitaAccordion.vue?vue&type=style&index=0&id=ec556f06&prod&lang=css"
import style1 from "./DisponibilitaAccordion.vue?vue&type=style&index=1&id=ec556f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec556f06",
  null
  
)

export default component.exports